export function getResponseData(response, fallback = {}) {
    if (!response || response.data === undefined || response.data === null) {
        return fallback
    }

    return response.data
}

export function asArray(value) {
    return Array.isArray(value) ? value : []
}
